export const appSelector = (state) => state.app;
export const formStartedSelector = (state) => state.app.formStarted;
export const formCompletedSelector = (state) => state.app.formCompleted;
export const isEditingSelector = (state) => state.app.isEditing;
export const isLoadingSelector = (state) => state.app.isLoading;
export const errorSelector = (state) => state.app.error;
export const errorMessageSelector = (state) => state.app.errorMessage;
export const appUrlsSelector = (state) => state.app.urls;
export const representativeSelector = (state) => state.app.representative;
export const servicesRequiredSelector = (state) => state.app.servicesRequired;
export const reasonsRequiredSelector = (state) => state.app.reasonsRequired;
export const servicesSelector = (state) => state.app.services;
export const categoriesSelector = (state) => state.app.categories;
export const categoriesErrorSelector = (state) => state.app.categoriesError;
export const codewordSelector = (state) => state.app.codeword;
export const postHospitalRecoveryEndDateSelector = (state) => state.app.postHospitalRecoveryEndDate;
export const temporaryLifeChangeEndDateSelector = (state) => state.app.temporaryLifeChangeEndDate;
export const youngHouseholderEndDateSelector = (state) => state.app.youngHouseholderEndDate;
export const languageSelector = (state) => state.app.language;
export const languagesSelector = (state) => state.app.languages;
export const autoEnrolSelector = (state) => state.app.autoEnrol;
export const additionalRequirementsSelector = (state) => state.app.additionalRequirements;
